import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-688b3ef8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shopping-button-wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "shopping-cart-number" }
const _hoisted_5 = { class: "body-wrapper" }
const _hoisted_6 = { class: "footer" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Totalt", -1))
const _hoisted_8 = { class: "price" }

import { router } from "@/router/router";
import CustomButton from "../generics/CustomButton.vue";
import CustomIcon from "../generics/CustomIcon.vue";
import CustomModal from "../generics/CustomModal.vue";
import TicketSummary from "./TicketSummary.vue";
import shoppingBag from "@/assets/SVG/shoppingBag.vue";
import { useBookingStore } from "@/store/bookingStore";
import { reactive } from "vue";
import { useTrackingStore } from "@/store/trackingStore";
import { useWindowSize } from "vue-window-size";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShoppingButton',
  setup(__props) {

const bookingStore = useBookingStore();
const trackingStore = useTrackingStore();

const { width, height } = useWindowSize();

const state = reactive({
  showSummary: false,
});

function handle_book_click() {
  trackingStore.trackEvent("view_item_list");
  router.push({ name: "cardbuy" });
}

function onNavButtonClick() {
  state.showSummary = false;
  router.push({ name: "cardbuy" });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CustomButton, {
        class: "booking-button",
        onClick: handle_book_click
      }, {
        default: _withCtx(() => [
          (_unref(width) > 480)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Boka här"))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(shoppingBag)
              ]))
        ]),
        _: 1
      }),
      (_unref(bookingStore).shoppingCart.length > 0 && _unref(width) > 480)
        ? (_openBlock(), _createBlock(CustomButton, { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "shopping-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (state.showSummary = true))
              }, [
                _createVNode(CustomIcon)
              ]),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(bookingStore).itemsInShoppingCart), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(CustomModal, {
      show: state.showSummary,
      onOnClose: _cache[1] || (_cache[1] = ($event: any) => (state.showSummary = false)),
      enterFrom: "right",
      fullHeight: true
    }, {
      header: _withCtx(() => [
        _createTextVNode(" Kundvagn ")
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bookingStore).shoppingCart, (ticket, index) => {
              return (_openBlock(), _createBlock(TicketSummary, {
                key: `summary-${ticket.id}-${index}`,
                ticketId: ticket.id,
                ageGroup: ticket.age,
                comfort: ticket.comfort,
                price: String(ticket.price),
                title: ticket.title
              }, null, 8, ["ticketId", "ageGroup", "comfort", "price", "title"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(bookingStore).totalPrice(_unref(bookingStore).shoppingCart)) + " Kr ", 1),
            _createVNode(CustomButton, { onClick: onNavButtonClick }, {
              default: _withCtx(() => [
                _createTextVNode("Gå till kassa")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})